"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlaceReservationConfirmation = void 0;
var PlaceReservationConfirmation;
(function (PlaceReservationConfirmation) {
    PlaceReservationConfirmation["successful"] = "successful";
    PlaceReservationConfirmation["failed"] = "failed";
    PlaceReservationConfirmation["outsideHours"] = "outsideHours";
})(PlaceReservationConfirmation || (exports.PlaceReservationConfirmation = PlaceReservationConfirmation = {}));
//# sourceMappingURL=PlaceReservationConfirmation.js.map